import React from 'react';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames';

import type { RootMenuItem } from '../../../../BettingMenu/types';
import { MENU_ITEM_TYPE } from 'app/modules/Navigation/types';

import { createMenuItemTestDataAttributesGetter } from '../../../../BettingMenu/test-data-helpers';
import { isSelectedMenuItem } from '../../../../BettingMenu/utils';
import { MenuItem } from '../../../MenuItem';
import { LinkContent } from '../LinkContent';

import styles from '../../RootMenu.module.scss';

type RootMenuItemProps = {
  entry: RootMenuItem;
};

export const Item: React.FC<RootMenuItemProps> = ({ entry }) => {
  const { pathname } = useLocation();

  const isSelectedSport = isSelectedMenuItem(entry, pathname);

  const itemClassName = classNames(
    styles.item,
    {
      [styles.itemSelected]: isSelectedSport,
    },
  );

  const getMenuItemTestDataAttributes = createMenuItemTestDataAttributesGetter(
    'service-menu-item',
    MENU_ITEM_TYPE.CONSTANT,
  );

  return (
    <MenuItem entry={entry}
              testDataAttributes={getMenuItemTestDataAttributes(entry)}
              to={entry.location}
              classNameItem={itemClassName}
              classNameLink={styles.link}>
      <LinkContent entry={entry} />
    </MenuItem>
  );
};
